import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {BehaviorFilters} from '../../../constants/Constants';
import {MenuItem} from '@techsmith/tsc-cloud-style-guide';

const BehaviorFilterMenu: React.FC<IBehaviorFilterMenuProps> = ({setFilter}) => {
   const {t} = useTranslation();

   return (
      <>
         <MenuItem
            key={BehaviorFilters.all}
            label={t('analytics.viewerStatus.all')}
            onClick={() => setFilter(BehaviorFilters.all)}
            testId="all-filter"
         />
         <MenuItem
            key={BehaviorFilters.partial}
            label={t('analytics.viewerStatus.partial')}
            onClick={() => setFilter(BehaviorFilters.partial)}
            testId="partial-filter"
         />
         <MenuItem
            key={BehaviorFilters.completed}
            label={t('analytics.viewerStatus.completed')}
            onClick={() => setFilter(BehaviorFilters.completed)}
            testId="completed-filter"
         />
      </>
   );
};

export default BehaviorFilterMenu;

export interface IBehaviorFilterMenuProps {
   setFilter(filter: BehaviorFilters): void;
}